import { QueryClient } from '@tanstack/react-query';
import { isHttpError } from '../src/shared/api/http';

/**
 * Shared QueryClient instance for use in both components and route loaders.
 * This ensures data fetched in loaders is available in components via React Query.
 */
let queryClient: QueryClient | null = null;

export function getQueryClient(): QueryClient {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // Mobile-first: longer cache times to reduce network requests
          staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh longer
          gcTime: 30 * 60 * 1000, // 30 minutes - keep in memory longer
          refetchOnWindowFocus: false,
          refetchOnMount: false, // Use cached data when navigating back
          retry: (failureCount, error) => {
            if (isHttpError(error) && error.status === 401) {
              return false;
            }

            if (
              error &&
              typeof error === 'object' &&
              ('status' in error || 'response' in error)
            ) {
              const status = 'status' in error ? error.status :
                            ('response' in error && error.response && typeof error.response === 'object' && 'status' in error.response)
                              ? error.response.status : undefined;
              if (status === 401 || (typeof status === 'number' && status >= 400 && status < 500)) {
                return false;
              }
            }
            return failureCount < 3;
          },
        },
      },
    });
  }
  return queryClient;
}

